'use client';

import { c as _c } from "react/compiler-runtime";
import { Checkbox, Field, FieldContent, FieldDescription, FieldError, FieldLabel } from '@repo/ui/components';
import { ComponentProps, ReactNode, useId } from 'react';
import { useFieldContext } from '../lib/form-context.ts';
export const FormCheckbox = t0 => {
  const $ = _c(30);
  let description;
  let label;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      description,
      disabled: t1,
      isPending: t2,
      label,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = description;
    $[2] = label;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    description = $[1];
    label = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const disabled = t1 === undefined ? false : t1;
  const isPending = t2 === undefined ? false : t2;
  const field = useFieldContext();
  let t3;
  if ($[6] !== field.state.meta.errors) {
    t3 = field.state.meta.errors ?? [];
    $[6] = field.state.meta.errors;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const errors = t3;
  const id = useId();
  const t4 = isPending || disabled;
  let t5;
  if ($[8] !== field) {
    t5 = checked => field.handleChange(checked === true);
    $[8] = field;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== field.state.value || $[11] !== id || $[12] !== props || $[13] !== t4 || $[14] !== t5) {
    t6 = <Checkbox checked={field.state.value} disabled={t4} id={id} onCheckedChange={t5} {...props} data-sentry-element="Checkbox" data-sentry-source-file="form-checkbox.tsx" />;
    $[10] = field.state.value;
    $[11] = id;
    $[12] = props;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== id || $[17] !== label) {
    t7 = <FieldLabel className="text-sm" htmlFor={id} data-sentry-element="FieldLabel" data-sentry-source-file="form-checkbox.tsx">{label}</FieldLabel>;
    $[16] = id;
    $[17] = label;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== description) {
    t8 = typeof description === "string" ? <FieldDescription className="nth-last-2:mt-0">{description}</FieldDescription> : description;
    $[19] = description;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== errors) {
    t9 = <FieldError className="text-sm" errors={errors} data-sentry-element="FieldError" data-sentry-source-file="form-checkbox.tsx" />;
    $[21] = errors;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t10 = <FieldContent data-sentry-element="FieldContent" data-sentry-source-file="form-checkbox.tsx">{t7}{t8}{t9}</FieldContent>;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t6) {
    t11 = <Field className="gap-2 has-[>[data-slot=field-content]]:*:[[role=checkbox]]:mt-0.75" orientation="horizontal" data-sentry-element="Field" data-sentry-component="FormCheckbox" data-sentry-source-file="form-checkbox.tsx">{t6}{t10}</Field>;
    $[27] = t10;
    $[28] = t6;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
};